import './style.scss';

import { AnimatePresence } from 'framer-motion';
import { StateMachineProvider } from 'little-state-machine';
import { Outlet } from 'react-router-dom';

import { AnimateTextTyping, Expand, ProgressBar } from '@/components';

import { Content } from '../content';

interface ILander10 {
	percent: number;
	message: string;
	done: boolean;
	setDone: (done: boolean) => void;
	handleNext: () => void;
	versionId: string;
	landerId: string;
}

export const Lander10 = ({
	percent,
	message,
	done,
	setDone,
	handleNext,
	landerId,
	versionId,
}: ILander10) => {
	const lander = Content[landerId][versionId]?.lander;
	console.log({ lander });

	return (
		<StateMachineProvider>
			<div className={`lander10__wrapper lander10__wrapper--v${versionId}`}>
				<img
					className={`lander10__wrapper__background--image`}
					src={lander?.bgImage}
					alt="background"
				/>
				<div className={`lander10__wrapper__gradient`} />
				<div className={`lander10__wrapper__container`}>
					<ProgressBar
						percent={percent}
						baseColor={lander?.progressBarBaseColor}
						progressColor={lander?.progressBarProgressColor}
						hidePercentage={lander?.hidePercentage}
						barWidth={lander?.progressBarWidth}
					/>
					<div
						className={`lander10__wrapper__container__content lander10__wrapper__container__content--v${versionId}`}
					>
						<div className={`lander10__wrapper__container__content__host`}>
							<div
								className={`lander10__wrapper__container__content__host--image lander10__wrapper__container__content__host--image--v${versionId}`}
							>
								<img
									src={lander?.hostImage}
									alt="host"
									className={`lander10__wrapper__container__content__host--image--avatar`}
								/>
							</div>
							<div
								className={`lander10__wrapper__container__content__host--bubble lander10__wrapper__container__content__host--bubble--v${versionId}`}
							>
								<AnimatePresence mode="wait">
									{message && (
										<AnimateTextTyping
											key={message}
											text={message}
											setDone={setDone}
											cursorBlinkerColor={lander?.progressBarProgressColor}
										/>
									)}
								</AnimatePresence>
							</div>
						</div>
						<Expand expanded={done} key={message}>
							<Outlet context={{ handleNext, landerId, versionId }} />
						</Expand>
					</div>
				</div>
			</div>
		</StateMachineProvider>
	);
};
